import "../../assets/css/blog.css";
import { useState } from "react";
const BlogSidebar = () => {
  const [inVisible, setInVisible] = useState(true);
  const topic = [
    {
      id: 1,
      list: "Topic 1",
    },
    {
      id: 2,
      list: "Topic 2",
    },
    {
      id: 3,
      list: "Topic 3",
    },
    {
      id: 4,
      list: "Topic 4",
    },
    {
      id: 5,
      list: "Topic 5",
    },
  ];

  const recentTopicHandler = () => {
    setInVisible((event) => !event);
  };

  return (
    <div className="sidebar-style">
      {/* this is old code */}
      {/* <div className="sidebar-widget">
        <h4 className="pro-sidebar-title">Search </h4>
        <div className="pro-sidebar-search mb-55 mt-25">
          <form className="pro-sidebar-search-form" action="#">
            <input type="text" placeholder="Search here..." />
            <button>
              <i className="pe-7s-search" />
            </button>
          </form>
        </div>
      </div>
      <div className="sidebar-widget">
        <h4 className="pro-sidebar-title">Recent Projects </h4>
        <div className="sidebar-project-wrap mt-30">
          <div className="single-sidebar-blog">
            <div className="sidebar-blog-img">
              <Link to={"/blog-details-standard"}>
                <img
                  src={
                    "/assets/img/blog/sidebar-1.jpg"
                  }
                  alt=""
                />
              </Link>
            </div>
            <div className="sidebar-blog-content">
              <span>Photography</span>
              <h4>
                <Link to={"/blog-details-standard"}>
                  T- Shart And Jeans
                </Link>
              </h4>
            </div>
          </div>
          <div className="single-sidebar-blog">
            <div className="sidebar-blog-img">
              <Link to={"/blog-details-standard"}>
                <img
                  src={
                    "/assets/img/blog/sidebar-2.jpg"
                  }
                  alt=""
                />
              </Link>
            </div>
            <div className="sidebar-blog-content">
              <span>Branding</span>
              <h4>
                <Link to={"/blog-details-standard"}>
                  T- Shart And Jeans
                </Link>
              </h4>
            </div>
          </div>
          <div className="single-sidebar-blog">
            <div className="sidebar-blog-img">
              <Link to={"/blog-details-standard"}>
                <img
                  src={
                    "/assets/img/blog/sidebar-3.jpg"
                  }
                  alt=""
                />
              </Link>
            </div>
            <div className="sidebar-blog-content">
              <span>Design</span>
              <h4>
                <Link to={"/blog-details-standard"}>
                  T- Shart And Jeans
                </Link>
              </h4>
            </div>
          </div>
          <div className="single-sidebar-blog">
            <div className="sidebar-blog-img">
              <Link to={"/blog-details-standard"}>
                <img
                  src={
                    "/assets/img/blog/sidebar-2.jpg"
                  }
                  alt=""
                />
              </Link>
            </div>
            <div className="sidebar-blog-content">
              <span>Photography</span>
              <h4>
                <Link to={"/blog-details-standard"}>
                  T- Shart And Jeans
                </Link>
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar-widget mt-35">
        <h4 className="pro-sidebar-title">Categories</h4>
        <div className="sidebar-widget-list sidebar-widget-list--blog mt-20">
          <ul>
            <li>
              <div className="sidebar-widget-list-left">
                <input type="checkbox" defaultValue />{" "}
                <Link to={"/blog-standard"}>
                  Women <span>4</span>{" "}
                </Link>
                <span className="checkmark" />
              </div>
            </li>
            <li>
              <div className="sidebar-widget-list-left">
                <input type="checkbox" defaultValue />{" "}
                <Link to={"/blog-standard"}>
                  Men <span>4</span>{" "}
                </Link>
                <span className="checkmark" />
              </div>
            </li>
            <li>
              <div className="sidebar-widget-list-left">
                <input type="checkbox" defaultValue />{" "}
                <Link to={"/blog-standard"}>
                  Bags <span>4</span>{" "}
                </Link>
                <span className="checkmark" />
              </div>
            </li>
            <li>
              <div className="sidebar-widget-list-left">
                <input type="checkbox" defaultValue />{" "}
                <Link to={"/blog-standard"}>
                  Accessories <span>4</span>{" "}
                </Link>
                <span className="checkmark" />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="sidebar-widget mt-50">
        <h4 className="pro-sidebar-title">Tag </h4>
        <div className="sidebar-widget-tag mt-25">
          <ul>
            <li>
              <Link to={"/blog-standard"}>
                Clothing
              </Link>
            </li>
            <li>
              <Link to={"/blog-standard"}>
                Accessories
              </Link>
            </li>
            <li>
              <Link to={"/blog-standard"}>
                For Men
              </Link>
            </li>
            <li>
              <Link to={"/blog-standard"}>
                Women
              </Link>
            </li>
            <li>
              <Link to={"/blog-standard"}>
                Fashion
              </Link>
            </li>
          </ul>
        </div>
      </div> */}

      <div className="blog_sidebar">
        <h5 className="">Similar Topic</h5>

        <div className="row">
          <div className="col-6">
            <div className="topic_img">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQTLlu2qNudnQgArtzDPWhc_aii0jkK8FJ-r3Ui8GEtGohIO6jsI8Y4YR-vB2skznvKvzo&usqp=CAU"
                alt=""
              />
              <span className="d-block mt-3">Topic 1</span>
            </div>
          </div>
          <div className="col-6">
            <div className="topic_img">
              <img
                src="  https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQTLlu2qNudnQgArtzDPWhc_aii0jkK8FJ-r3Ui8GEtGohIO6jsI8Y4YR-vB2skznvKvzo&usqp=CAU"
                alt=""
              />
              <span className="d-block mt-3">Topic 2</span>
            </div>
          </div>
        </div>

        <div className="recent_topic mt-5">
          <h4 onClick={recentTopicHandler}>Recent Topics</h4>

          <div className={`topic_list_content ${inVisible ? "opened" : ""}`}>
            <ul>
              {topic.map((list, index) => (
                <li className="topic_list" key={index}>
                  {list.list}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="must_read mt-5">
          <h4 className="mb-4">Must Read</h4>
          <div className="row">
            <div className="col-6">
              <div className="topic_img">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1_uHGbzN0Y9vr41ZZp_oyb4XJ6IacPWG2rJXX6sn4jVrvcxiyGjELUI0&s"
                  alt=""
                  width={"100%"}
                  height={"100%"}
                />
                <span className="d-block mt-3">Topic 1</span>
              </div>
            </div>
            <div className="col-6">
              <div className="topic_img">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXvocjLpPoIY0dYN6UXyWGA08RmaLst2yPK_SIt1F3WWZ65ksklus8OlpmQ6osAt04mww&usqp=CAU"
                  alt=""
                  width={"100%"}
                  height={"100%"}
                />
                <span className="d-block mt-3">Topic 2</span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="topic_img mt-4">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPHhvmYhLsXTXQqCctH19hE2SXMGSJBZEIuGWQ9vjYcd6jSmMtx9krT5-Rz7Id4PGIcTc&usqp=CAU"
                  alt=""
                  width={"100%"}
                  height={"100%"}
                />
                <span className="d-block mt-3">Topic 3</span>
              </div>
            </div>
            <div className="col-6">
              <div className="topic_img mt-4">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRL0e1DM50rtw938ipjKHy7fCYZHcvv5vO31T_vr8Qy1ILoGDIpvEgjkUg&s"
                  alt=""
                  width={"100%"}
                  height={"100%"}
                />
                <span className="d-block mt-3">Topic 4</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogSidebar;
